export class NewComment {
  public id: number;
  public userId: number;
  public replyTo: number;
  public text: string;
  public userName: string;
  public userEmail: string;
  public editIndex: number;
}



// WEBPACK FOOTER //
// ./src/app/modules/common-main/components/news-layout/model/new-comment.ts